class Graphic {
	static fromArray(data, list) {
		let inst = new Graphic(list);
		inst._id = data.shift();
		inst._name = data.shift();
		inst._unloadedOn = data.shift();
		inst._ownerName = data.shift();
		inst._access = data.shift();
		inst._editable = data.shift();

		return inst;
	}

	constructor(list) {
		this._list = list;
		this._id = 0;
		this._name;
		this._uploadedOn;
		this._ownerName;
		this._access;
		this._editable;

		this._elem = null;
		this._chkBox = chk('alt-chk');
		this._shareBtn = null;
		this._deleteBtn = null;
	}

	get id() {return this._id;}

	get checked() {return this._chkBox.checked;}
	set checked(v) {this._chkBox.checked = !!v;}

	get elem() {
		if (this._elem === null) this.buildElem();
		return this._elem;
	}

	buildElem() {
		if (this._access >= AC.ACCESS_FULL) {
			this._shareBtn = btn('btn i-rg i-share');
			onEv(this._shareBtn, 'click', this.showSharing.bind(this));
		}
		if (this._access == AC.ACCESS_OWNER) {
			this._deleteBtn = btn('btn i-rg i-delete');
			onEv(this._deleteBtn, 'click', this.delete.bind(this));
		}

		this._elem = div('image-list-item', [
			this._img = img(null, graphicSrc(this._id, AC.GRAPHIC_MED)),
			div('overlay top hstack', [
				this._chkBox,
				span('i-rg chk-box', null, {'click': this.select.bind(this)}),
				this._tagBtn = btn('btn i-rg i-tags'),
				this._shareBtn,
				this._deleteBtn
			]),
			div('overlay bottom', [
				p(null, this._name)
			])
		], {
			'click': this.edit.bind(this)
		});

		onEv(this._tagBtn, 'click', this.showTags.bind(this));
	}

	edit(ev) {
		if (this._list._selection.empty) {
			if (this._editable) GraphicEditor.fromId(this._id);
		}
		else {
			this.select(ev);
		}
	}

	select(ev) {
		stopEv(ev);
		this._list._selection.toggle(this);
	}

	showTags(event) {
		this._list._tags.mapOne(this.id, this._tagBtn, event);
	}

	showSharing(ev) {
		stopEv(ev);
		if (isCommunity) {
			this._list._sharing.mapOne(this.id, this._shareBtn);
		}
		else {
			this._list._sharing.mapOne(this.id);
		}
	}

	delete(ev) {
		stopEv(ev)
		Dialog.Confirm(
			_("Deleting this graphic, this CANNOT be undone!"),
			_("DELETE GRAPHIC"),
			() => {
				API.delete('graphics/' + this._id)
				.then(_ => document.dispatchEvent(new Event('primaryDataInvalid')));
			}, null, WARNING_DELETE_GRAPHIC_SINGLE
		);
	}
}